import { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { ViewMode } from "./viewMode";
import './greeting.css'
import { Link } from "react-router-dom";
import { ChildComponentRef } from "./childComponent";

const About = forwardRef((props, ref) => {
    const divRef = useRef<HTMLDivElement | null>(null);
    const [childComponentBrightness, setChildComponentBrightness] = useState<number>(0);
    const [childComponentFontSize, setChildComponentFontSize] = useState<number>(0);
    const [childComponentLocation, setChildComponentLocation] = useState<{x:number, y:number}>({x:0, y:0});
    const [childComponentSize, setChildComponentSize] = useState<{x:number, y:number}>({x:0, y:0});
    const [viewMode, setViewMode] = useState<ViewMode>();
    const [windowSize, setWindowSize] = useState<{width: number, height: number}>();
    const updateChildComponentBrightness = (gb: number) => setChildComponentBrightness(gb);
    const updateChildComponentFontSize = (gfs: number) => setChildComponentFontSize(gfs);
    const updateChildComponentLocation = (gl: {x:number, y:number}) => setChildComponentLocation(gl);
    const updateChildComponentSize = (gs: {x:number, y:number}) => setChildComponentSize(gs);
    const updateViewMode = (vm: ViewMode, width?: number, height?: number) => {
        setViewMode(vm);
        if (width && height) setWindowSize({width, height});
    }
    useImperativeHandle(ref, (): ChildComponentRef => ({
        name:'About', updateChildComponentBrightness, updateChildComponentLocation, updateChildComponentSize, updateChildComponentFontSize, updateViewMode, divRef
    }));


    const introText = 'My journey has been defined by a love for design and creation, spanning the realms of architecture, software development, and generative art. I find fulfillment in exploring the endless possibilities within each discipline. Here is a closer look at my background.';
    const architectureTitle = 'Architect';
    const architectureText = "For over three years, I've been part of architectural offices, crafting innovative spaces through conceptual design and BIM modeling for public, mixed-use, and industrial buildings. Since 2020, my journey has led me to academia, where I am currently a PhD student exploring the possibilities of implementing Machine Learning for sustainable architecture. Specializing in Building Performance Optimization, I use advanced simulation engines and algorithms to enhance building effectiveness. My ultimate goal is to shape the future of architecture by creating cutting-edge tools and methodologies that seamlessly integrate modern building technologies into design projects.";
    const softwareTitle = 'Software Developer';
    const softwareText = "Holding a bachelor's degree in Software Development (full-stack), I've developed web services for individual clients, merging functionality with creativity. As a versatile professional, I uniquely bridge the worlds of architecture and technology, constantly seeking to innovate and create something extraordinary.";
    const artistTitle = 'Generative Artist';
    const artistText = "Generative Art is where my heart truly sings. I spend countless hours creating abstract animations, experimenting with shaders, and bringing various effects to life. This passion led me to create several NFT collections accepted by ArtBlocks, one of the premier platforms for generative artists in the NFT space. My work has also been showcased in numerous galleries and events dedicated to generative and new media art.";
    const inspirationTitle = 'My Inspiration';
    const inspirationText = "Ever since my school days, I've been captivated by the beauty of math and geometry, and how they can elegantly describe the world around us. The chaos theory, which reveals the simple beauty behind seemingly chaotic events, fascinates me. In my art, I love to experiment with math, geometry, and the science of light and color, always striving to uncover new dimensions of creativity.";
    const passionTitle = 'My Passion';
    const passionText = "I am deeply passionate about everything I do. Whether it's designing architecture, developing software, or creating generative art, I pour my heart and soul into it. My work is a constant evolution, always pushing the boundaries of what's possible by blending architecture, software development, and creative vision.";
    
    const componentStyle: React.CSSProperties = {
        position: "fixed",
        top: `${childComponentLocation.y}px`,
        left: `${childComponentLocation.x}px`,
        transform: "translate(-50%, 0%)",
        width: `${childComponentSize.x}px`,
        height: childComponentSize.y? `${childComponentSize.y}px` : 'auto',
        opacity: `${childComponentBrightness}`
    }
    const desktopStyle: React.CSSProperties = {
        backgroundColor: "rgba(0, 0, 0, .6)",
        padding: '20px 20px'
    }
    const mobileStyle: React.CSSProperties = {
        backgroundColor: "rgba(0, 0, 0, .6)",
        padding: '10px 10px'
    }
    const titleTextStyle: React.CSSProperties = {
        margin: '25px 0 5px 0',
        textAlign: "justify",
        color: "white",
        fontFamily: "Roboto Condensed",
        fontWeight: 400,
        fontSize: `${childComponentFontSize}px`,
    }
    const regularTextStyle: React.CSSProperties = {
        margin: 0,
        textAlign: "justify",
        color: "white",
        fontFamily: "Open Sans",
        fontWeight: 300,
        fontSize: `${childComponentFontSize - 8}px`,
    }

    return (
        <div ref={divRef} style={componentStyle}>
            <div style={viewMode?.size == 'desktop'? desktopStyle : mobileStyle}>
                <p style={regularTextStyle}>{introText}</p>
                <h2 style={titleTextStyle}>{architectureTitle}</h2>
                <p style={regularTextStyle}>{architectureText}</p>
                <h2 style={titleTextStyle}>{softwareTitle}</h2>
                <p style={regularTextStyle}>{softwareText}</p>
                <h2 style={titleTextStyle}>{artistTitle}</h2>
                <p style={regularTextStyle}>{artistText}</p>
                <h2 style={titleTextStyle}>{inspirationTitle}</h2>
                <p style={regularTextStyle}>{inspirationText}</p>
                <h2 style={titleTextStyle}>{passionTitle}</h2>
                <p style={regularTextStyle}>{passionText}</p>
            </div>
            <div className="links-container" style={{fontSize: `${childComponentFontSize}px`}}>
                <Link to="/" style={{marginRight: 'auto'}}>{"< Back"}</Link>
                <Link to="/cv">CV</Link>
                <Link to="/contacts" style={{marginLeft: 'auto'}}>Contacts</Link>
            </div>
        </div>
    )
});

export default About